import { useState } from 'react';
import { motion } from 'framer-motion';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new URLSearchParams();
      
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('company', formData.company);

      const response = await fetch('https://readdy.ai/api/form/d52r49t45eoa1ne7l6eg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      if (response.ok) {
        setIsSubmitted(true);
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({ name: '', email: '', company: '' });
        }, 3000);
      } else {
        alert('Gönderim başarısız oldu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Form gönderim hatası:', error);
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 px-6 bg-[#1A2B4A] text-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-3 space-y-8"
          >
            <h2 className="text-5xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Hemen Başlayın, Farkı Yaşayın
            </h2>

            <p className="text-lg text-blue-100 leading-relaxed max-w-2xl">
              IT envanter yönetiminizi dijitalleştirin, zimmet süreçlerinizi otomatikleştirin. 
              ManageEngine ServiceDesk Plus entegrasyonu ile tüm cihazlarınızı tek platformdan yönetin.
            </p>

            <div className="flex flex-wrap gap-8 pt-8">
              <div className="flex items-center space-x-3">
                <i className="ri-lock-line text-2xl text-green-400"></i>
                <span className="font-medium">KVKK Uyumlu</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-shield-check-line text-2xl text-green-400"></i>
                <span className="font-medium">ISO 27001</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-customer-service-2-line text-2xl text-green-400"></i>
                <span className="font-medium">7/24 Destek</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold mb-6">Bilgi Alın</h3>
              
              {isSubmitted ? (
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="text-center py-12"
                >
                  <i className="ri-check-line text-6xl text-green-400 mb-4"></i>
                  <p className="text-xl font-semibold">Mesajınız alındı!</p>
                  <p className="text-blue-100 mt-2">En kısa sürede size dönüş yapacağız.</p>
                </motion.div>
              ) : (
                <form 
                  id="contact-form" 
                  data-readdy-form 
                  onSubmit={handleSubmit} 
                  className="space-y-4"
                >
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Adınız Soyadınız"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="w-full px-4 py-3 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-white/60 focus:border-[#FF6B35] focus:outline-none transition-all"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="E-posta Adresiniz"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="w-full px-4 py-3 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-white/60 focus:border-[#FF6B35] focus:outline-none transition-all"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="company"
                      placeholder="Şirket Adı"
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      required
                      className="w-full px-4 py-3 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-white/60 focus:border-[#FF6B35] focus:outline-none transition-all"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-4 bg-[#FF6B35] text-white rounded-lg font-semibold text-lg hover:bg-[#FF5722] transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? 'Gönderiliyor...' : 'Bilgi Al'}
                  </button>
                </form>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;